import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button } from '../../../../components';

import css from './SectionHero.css';
import { createResourceLocatorString } from '../../../../util/routes';
import routeConfiguration from '../../../../routeConfiguration';

export default () => {
    const history = useHistory();
    const currentUserDefined = useSelector(state => Boolean(state.user?.currentUser?.id?.uuid));
    return (
        <section className={css.root}>
            <div className={css.content}>
                <h1 className={css.subHeading}>Flip & Win</h1>
                <p className={css.heading}>
                    Täglich Credits und Preise deiner Lieblingsmarken gewinnen!
                </p>
                <p className={css.description}>
                    {`Nutze täglich deine Chance auf kostenlose Credits. \nZusätzlich warten tolle Preise von Marken, die Du liebst.`}
                </p>
            </div>
            {!currentUserDefined && (
                <footer className={css.footer}>
                    <Button
                        className={css.subLinkPrimary}
                        type="button"
                        onClick={() =>
                            history.push(
                                createResourceLocatorString('SignupPage', routeConfiguration())
                            )
                        }
                    >
                        Kostenlos registrieren
                    </Button>
                </footer>
            )}
        </section>
    );
};
